<template>
  <!-- Modal -->
  <div class="modal fade" id="ArchiveStockDownloadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('inventory.download_csv')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="table-scroll">
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th class="width-20">
                    <div class="form-check">
                      <input class="form-check-input pointer-clickable" type="checkbox" v-model="selectAll" value="1" id="defaultCheck01">
                      <label class="form-check-label pointer-clickable" for="defaultCheck01">{{translations('inventory.choice')}}</label>
                    </div>
                  </th>
                  <th>{{translations('inventory.item_name')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(item, i) in items">
                  <tr :key="i">
                    <td>
                      <div class="form-check">
                        <input class="form-check-input pointer-clickable" type="checkbox" v-model="selectedIndex" :value="item.id" :id="'defaultCheck'+i">
                        <label class="form-check-label" :for="'defaultCheck'+i"></label>
                      </div>
                    </td>
                    <td>{{ item.name }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer  justify-content-between">
          <div>
            <button v-if="Number($parent.allowedCostDownload) === 1 && !$parent.isAdmin" type="button" class="btn btn-link p-0 decoration-underline disabled">{{translations('inventory.applying_cost_download')}}</button>
            <button v-else-if="Number($parent.allowedCostDownload) !== 2 && !$parent.isAdmin" type="button" class="btn btn-link p-0 decoration-underline" @click="approvalRequest()">{{translations('inventory.cost_download_approval_application')}}</button>
          </div>
          <div>
            <button ref="closeMonthModal" type="button" class="btn btn-secondary margin-right-10" data-dismiss="modal">{{translations('common.close')}}</button>
            <button type="button" class="btn btn-primary" @click="downloadCSV()">{{translations('inventory.download_csv')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveStockDownloadModal',
  props: {
    items: {}, // IN
    csvFieldIndex: {} // OUT
  },
  components: {
    VueElementLoading
  },
  data () {
    return {
      selectAll: 0,
      selectedIndex: [],
      isSearching: false
    }
  },
  watch: {
    selectAll (v) {
      this.selectAll = v
      this._selectAll()
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    confirmationDownloadInventoryCostMessage () {
      return this.translations('inventory.message_notification_download_inventory_costs')
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    }
  },
  created () {
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    approvalRequest () {
      this.$dialog.confirm(this.confirmationDownloadInventoryCostMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      }).then(async () => {
        await this.updateUsers()
      })
    },
    async updateUsers () {
      let self = this
      try {
        const paramUpdate = {}
        paramUpdate['allow_cost_download'] = 1 // 0初期、1申請中、2承認済
        paramUpdate.user_id = self.$store.getters['User/id']

        const response = await this.$http.post(this.$api_url.account_update, paramUpdate)
        const result = response.data
        if (result.status === true) {
          this.$parent.getUser() // REFRESH
          this.$toastr.success('承認を申請しました。', 'Success')
        } else {
          this.$toastr.error('予期せぬエラーが発生しました。', 'エラー')
        }
      } catch (error) {
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    downloadCSV () {
      let self = this
      if (this.selectedIndex.length === 0) {
        this.$toastr.warning(this.translations('inventory.message_notification_pick_item'))
        return
      }
      let permissionError = false
      this.selectedIndex.forEach(function (v) {
        if (Number(v) === 6 && Number(self.$parent.allowedCostDownload) !== 2 && !self.$parent.isAdmin) { // 6在庫原価 // 0初期、1申請中、2承認済
          permissionError = true
        }
      })
      if (permissionError) {
        this.$toastr.warning(this.translations('inventory.message_notification_permission_download_inventory_costs'))
        return
      }

      while (this.$props.csvFieldIndex.length) { self.$props.csvFieldIndex.pop() } // CLEAR ALL
      this.selectedIndex.forEach(function (v) {
        self.$props.csvFieldIndex.push(v)
      })
      this.$parent.export_csv()
    },
    _selectAll () {
      if (this.selectAll) {
        let self = this
        this.items.forEach(function (v) {
          self.selectedIndex.push(v.id)
        })
      } else {
        this.selectedIndex = []
      }
    }

  }
}
</script>
